import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import scope from "../../../assests/scopuslogo.png";
import score from "../../../assests/score.png";
import { Link } from "react-router-dom";

function Section1() {
  return (
    <>
         <Container className="my-5 px-3">
        <div className="p-md-4 p-2 mb-4 shadow rounded-4">
          <Row className="py-4">
            <Col lg={7} md={8} sm={12}>
            
            <h2 className="display-6 fw-bold mb-3 px-2">About the Journal</h2>
              <p className="joab-common-para mb-3 px-2">
                The Journal of Applied Bioanalysis is a publication that stands
                at the forefront of advancements in the field of bioanalysis.
                This peer-reviewed journal serves as a vital platform for
                researchers, scientists, and practitioners to share and
                disseminate their cutting-edge research, innovative
                methodologies, and practical applications across various
                domains of bioanalysis.
              </p>
              <h2 className="display-6 fw-bold my-4 px-2">Editor-in-Chief</h2>
              <p className="px-2">Ali S. Saad
                
              </p>
            </Col>

            <Col lg={5} md={4} sm={12} className="joab_common_div">
              <div className="px-lg-5 px-md-2 px-1 mt-4">
              <Link to="https://www.scopus.com/sourceid/21101122745" target="_blank"> 
                <img
                  src={scope}
                  alt="scopusimg"
                  className="jab_home_section1_img"
                />
            
                 <img
                  src={score}
                  alt="scopusimg"
                  className="jab_home_section1_img"
                />
                    </Link>
              </div>
            </Col>
          </Row>
        </div>
      </Container>
    </>
  );
}

export default Section1;
